import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import CustomLoader from './Loader';

function PinInput() {
    const pinSize= 4;
    const [pinInput, setPinInput]= useState("");
    const [errMsg, setErrMsg]= useState(null);
    const inputRefs= useRef([]);
    const [loginButton, setLoginButton]= useState(true);
    const {vendorId}= useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading]= useState(false);

    useEffect(()=>{
        const currentIndex = Math.min(pinInput.length, pinSize - 1);
        if (inputRefs.current[currentIndex]) inputRefs.current[currentIndex].focus();
        if(pinInput.length==pinSize) setLoginButton(false);
        else setLoginButton(true);
    },[pinInput])

    useEffect(() => {
        if (inputRefs.current[0]) inputRefs.current[0].focus();
    }, []);

    async function getbatches() {
        try {
            setIsLoading(true);
            setLoginButton(true);
            const res= await fetch(`/server/fodder_portal_access_free_function/batches`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Upin: pinInput,
                    vendorId: vendorId
                })
            })
            const response= await res.json();
            console.log(response);
            if(!response.data) throw Error("Incorrect PIN");

            sessionStorage.setItem("vendorId", vendorId);
            sessionStorage.setItem("vendorPin", pinInput);
            navigate("/dashboard", {state: {batchData: response.data}});
        } catch (error) {
            setErrMsg(error.message);
        }
        finally{
            setLoginButton(false);
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className='w-full h-12 flex justify-between'>
                {
                    Array.apply(null, Array(pinSize)).map((val, index)=>{
                        return (
                            <React.Fragment key={index}>
                                <input 
                                    ref={(el)=>inputRefs.current[index]=el}
                                    onChange={(e)=>{
                                        if(e.target.value.length>1) return;
                                        setPinInput((prev)=>prev+e.target.value);
                                    }}
                                    onKeyDown={(e)=>{if(e.key=="Backspace")setPinInput((prev)=>prev.substring(0,prev.length-1));}}
                                    type="number" 
                                    className={`w-1/5 border-2 border-foreground rounded-md text-center app ${index==pinInput.length?'outline':'outline-none'}`}
                                    disabled={pinInput.length==index || (pinInput.length==pinSize && index==pinSize-1)?false:true}
                                    value={pinInput.charAt(index)}
                                    autoFocus={true}
                                />
                            </React.Fragment>
                        )
                    })
                }
            </div>
            <button 
                className={` text-white w-full rounded-md p-2 ${loginButton?'bg-blue-400':'hover:bg-blue-400 bg-blue-500'}`}
                disabled={loginButton}
                onClick={getbatches}
            > 
                {
                    !isLoading?
                    "Login"
                    :
                    <CustomLoader size={5} color={"#111111"}/>
                }
            </button>
            {
                errMsg? <div className='text-red-500 text-xs'>**{errMsg}**</div>:null
            }
        </>
    )
}

export default PinInput